import loadable from '@loadable/component';
import { AppRouteConfig, PageRouteData, routePathWithCity } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ClientWebRouteViewModel } from '@common/model/meta/clientWebRouteViewModel';
import { Layout } from 'src/app/shared/components/layout';

interface CreateRoutesConfigOptions {
  defaultCityAlias?: string;
  pageIdToRouteData: Partial<{ [K in ClientWebPage]: Partial<PageRouteData<K>> }>;
}

export const createRoutesConfig = (routes: ClientWebRouteViewModel[], options: CreateRoutesConfigOptions): AppRouteConfig => {
  const { defaultCityAlias, pageIdToRouteData } = options;
  const generatedRoutes: AppRouteConfig[] = [];

  for (const route of routes) {
    const pageRouteData = pageIdToRouteData[route.pageId as ClientWebPage];

    if (!pageRouteData) {
      // eslint-disable-next-line no-undef
      if (process.env.NODE_ENV === 'development') {
        console.error(`Route (id: ${route.id}) with path "${route.path}" hasn't pageRouteData! Skip...`);
      }
      continue;
    }

    const { hasCitySeparatedContent } = pageRouteData;
    const { path, pageId, props } = route;

    generatedRoutes.push({
      ...pageRouteData,
      path: hasCitySeparatedContent ? routePathWithCity(path) : path,
      pageId,
      props,
      exact: true,
      defaultCityAlias: hasCitySeparatedContent ? defaultCityAlias : undefined,
      routeId: route.id,
    } as AppRouteConfig);
  }

  return {
    exact: true,
    component: Layout,
    routes: [
      ...generatedRoutes,
      {
        path: '*',
        exact: true,
        component: loadable(() => import('./notFound')),
        pageId: ClientWebPage.NotFound,
        hasCitySeparatedContent: false,
      },
    ],
    hasCitySeparatedContent: false,
  };
};
